import { FC, HTMLAttributes, ReactNode } from 'react';

import { FlexContainerStyled } from './FlexContainer.styled';

type FlexPropsT = HTMLAttributes<HTMLParagraphElement> & {
  children: ReactNode;
  align?: 'start' | 'end' | 'center' | 'stretch';
  direction?: 'row' | 'row-reverse' | 'column' | 'column-reverse';
  justify?: 'center' | 'between' | 'around' | 'start' | 'end' | 'flex-start' | 'flex-end';
};

const FlexContainer: FC<FlexPropsT> = ({ children, ...restProps }) => {
  return <FlexContainerStyled {...restProps}>{children}</FlexContainerStyled>;
};

export default FlexContainer;
